import React from 'react';
import { LocalStorageHelper } from '@nice-ccf/core-sdk';

/**
 *
 * @param key - storge key
 * @param setter - function to set value
 * @example SetSwitchHelper(NotificationSettings.SECONDARYDEVICE, setSecondaryDevice);
 *
 * Todo move to API when that epic is ready
 */
export function SetSwitchHelper(
  key: string,
  setter: React.Dispatch<React.SetStateAction<boolean>>
) {
  //  const switchValue: boolean
  const value = LocalStorageHelper.getItem(key) as string;

  if (value !== '') {
    setter(value === 'true');
  }
}

/**
 *
 * @param key - storge key
 * @param setter - function to set value
 * @example SetItemHelper(NotificationSettings.SECONDARYDEVICE, setSecondaryDevice);
 */
export function SetItemHelper(
  key: string,
  setter: React.Dispatch<React.SetStateAction<number>>
) {
  const storedValue = LocalStorageHelper.getItem(key) as number;

  if (storedValue) {
    setter(storedValue);
  }
}
